import React from 'react';
import DialogContainer from './Dialog.Container';
import DialogHeader from './Dialog.Header';
import DialogBody from './Dialog.Body';
import DialogFooter from './Dialog.Footer';
import type { RouterStore } from 'stores/RouterStore';
import injectStores from 'components/RootStore/injectStores';

interface DialogProviderProps {
  children: React.ReactNode;
  routerStore?: RouterStore;
}

const DialogProvider = injectStores((props: DialogProviderProps) => {
  const { children, routerStore } = props;
  const showDialog = !!routerStore?.queryParams?.dialogName;
  if (showDialog) {
    const { renderDialog } = routerStore;
    if (!renderDialog || !renderDialog.component) return children;
    return (
      <>
        {children}
        <DialogContainer>
          <DialogHeader />
          <DialogBody />
          <DialogFooter />
        </DialogContainer>
      </>
    );
  }
  return <>{children}</>;
});

export default DialogProvider;
